import TrainingCamp from './TrainingCamp/TrainingCamp.store';
import TrainingCamps from './TrainingCamps/TrainingCamps.store';

export default {
  namespaced: true,
  modules: {
    TrainingCamp,
    TrainingCamps,
  },
};
